import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ConceptosGastosCreate() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setName("");
  };

  const saveConceptosGastos = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_CONCEPTOS_GASTOS,
        {
          name,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Concepto Gastos",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <Form onSubmit={saveConceptosGastos}>
        <FormGroup>
          <Label for="exampleEmail">Concepto</Label>
          <Input
            type="text"
            name="email"
            id="exampleEmail"
            placeholder="Nombre del Concepto"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </FormGroup>
        <div className="submit-bar">
          {validaBoton ? (
            <Button type="submit" className="btn btn-success">
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          )}
          <div>
            <SweetAlert
              show={text}
              title="Creado con Exito"
              onConfirm={() => {
                setText(false);
              }}
            />
          </div>
        </div>
      </Form>
    </>
  );
}

export default ConceptosGastosCreate;
